import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import { WA_MESSAGES, WHATSAPP_DISPLAY, openWhatsApp } from '../../../config/site';

export const FAQS = [
  {
    q: 'What is Nitin Online Book?',
    a: "Nitin Online Book is India's premium online gaming platform and the official home of Nitin Online Book. You get live casino tables, cricket and football books, instant-win games, secure gaming India wide, and a WhatsApp desk that handles everything from your first deposit to your fastest withdrawal.",
  },
  {
    q: 'How do I complete my Nitin online book sign up?',
    a: 'Message the VIP desk on WhatsApp at ' +
      WHATSAPP_DISPLAY +
      '. Share your name and preferred game, and your Nitin Online Book ID is created in about two minutes — no long forms, no hidden charges, and your welcome bonus is applied before your first bet.',
  },
  {
    q: 'I need help with my Nitin online book login. What do I do?',
    a: 'Send "login help" to our WhatsApp number and the desk will verify you and restore access immediately. We never ask for your OTP or your full banking password — anyone who does is not us.',
  },
  {
    q: 'Where can I get the Nitin online book app download?',
    a: 'The official Nitin online book app download link for Android and iOS is issued directly by the support desk on WhatsApp, so you always receive the latest signed build with live game updates and instant payout notifications.',
  },
  {
    q: 'How fast are withdrawals, really?',
    a: 'Our average across the last 10,000 withdrawals is 4 minutes 51 seconds via UPI, wallets or net banking, running 24×7 including weekends and festivals. If anything is delayed, message the desk and it gets escalated straight away.',
  },
  {
    q: 'Is Nitin Online Book safe and secure?',
    a: 'Yes. Every session runs on 256-bit encryption, accounts are KYC-verified, game RNGs are audited monthly, and we have operated for three years with zero security incidents. Responsible-gaming limits and cool-off periods are available on request — 18+ only.',
  },
];

const FaqSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="relative overflow-hidden py-24">
      <span className="aurora right-[-6%] top-[16%] h-80 w-80 bg-royal-violet/25" aria-hidden="true" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="badge-pill"><Icon name="HelpCircle" size={13} /> Questions, answered</span>
          <h2 className="mt-6 font-heading text-display font-bold text-white">
            Everything about <span className="gold-text">Nitin Online Book</span>
          </h2>
          <p className="mt-4 text-body-lg text-white/60">
            Login, sign up, app download, payouts and safety — the six questions the desk answers most.
          </p>
        </div>

        <div className="mt-12 space-y-4">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-all duration-400 ease-royal ${
                  isOpen
                    ? 'border-royal-gold/45 bg-white/[0.06] shadow-[0_24px_50px_-30px_rgba(240,194,75,0.7)]'
                    : 'border-white/8 bg-white/[0.03] hover:border-white/20'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-display text-xs font-bold transition ${
                        isOpen ? 'bg-gradient-royal text-[#150F02]' : 'bg-white/8 text-white/50'
                      }`}
                    >
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="font-display text-base font-semibold text-white">{item.q}</span>
                  </span>
                  <Icon
                    name="ChevronDown"
                    size={19}
                    className={`shrink-0 text-royal-gold transition-transform duration-400 ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>

                <div
                  className="grid transition-all duration-400 ease-royal"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 pl-[4.25rem] text-sm leading-relaxed text-white/60">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="panel-gold mt-10 flex flex-col items-center gap-4 p-7 text-center sm:flex-row sm:text-left">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-wa-green/15 text-wa-green">
            <FaWhatsapp size={26} />
          </span>
          <div className="flex-1">
            <p className="font-display text-base font-semibold text-white">Still have a question?</p>
            <p className="text-sm text-white/55">
              The VIP desk replies in under two minutes, day or night — {WHATSAPP_DISPLAY}
            </p>
          </div>
          <button onClick={() => openWhatsApp(WA_MESSAGES.support)} className="btn-3d btn-3d-wa !py-3 text-sm">
            Ask on WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
